<div class="flex flex-col">
    <app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
  </div>
